import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { MembershipType } from 'src/features/membershipType/types';

const RESOURCE = 'sp-core/:parkingId/memberships/membership-type/:typeId/activate/';

type MutationFnType = typeof mutationFn;

type DTO = {
    parkingId: string;
    typeId: string;
};

const mutationFn = ({ parkingId, typeId }: DTO): Promise<MembershipType> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, typeId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useActivateMembershipType };
